import { DangerModal, showToast } from '@lokalise/louis'
import { useDeleteProfile } from '../../hooks/useDeleteProfile'
import type { UserCreatedProfile } from '../../types/tag'
import { showUnexpectedErrorToast } from '../../utils/toast'

type DeleteUserCreatedProfileModalProps = {
  profile: UserCreatedProfile
  onClose: () => void
}
export const DeleteUserCreatedProfileModal = ({
  profile,
  onClose,
}: DeleteUserCreatedProfileModalProps) => {
  const { deleteProfile, isPending } = useDeleteProfile({
    onSuccess: () => {
      showToast({ type: 'success', title: `${profile.name} has been deleted successfully.` })
      onClose()
    },
    onError: showUnexpectedErrorToast,
  })

  const onConfirm = () => {
    deleteProfile({ profileId: profile.id })
  }

  return (
    <DangerModal
      opened
      loading={isPending}
      title={`Delete ${profile.name}`}
      confirmText="Delete"
      closeText="Cancel"
      onClose={onClose}
      onConfirm={onConfirm}
    >
      You’re about to delete {profile.name}. It will stop running in all projects where it’s
      currently assigned and will automatically be replaced by the Base AI profile.
    </DangerModal>
  )
}
